// Discriminates an Algolia hit by its document shape.
// Centralises the field-presence checks that were previously
// duplicated across TopNavSearchBar, SearchResultsContainer,
// and SectionHomeAddToClassCell.

// @returns {'repo' | 'folder' | 'set' | 'question' | null}
export function getHitKind(hit) {
  if (!hit) return null
  if (hit.createdBy !== undefined) return 'repo'
  if (hit.ancestors !== undefined) return 'folder'
  if (hit.questions !== undefined) return 'set'
  if (hit.choices !== undefined) return 'question'
  return null
}
